import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const HomeOutlined = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M9.994 1.25c.331 0 .65.132.884.366l8.756 8.756a1.25 1.25 0 0 1-1.768 1.768l-1.616-1.616V17.5c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25v-6.988L2.122 12.14a1.25 1.25 0 1 1-1.768-1.768L9.11 1.616a1.25 1.25 0 0 1 .884-.366M6.25 8.012v8.238h7.5V8.024L9.994 4.268z" }) }));
});
HomeOutlined.displayName = 'HomeOutlined';
HomeOutlined.__iconComponentType = 'standard';
export default HomeOutlined;
//# sourceMappingURL=HomeOutlined.js.map